module.exports = __webpack_public_path__ + "img/IMG_1461.b7ee2793.jpg";